import { useState } from 'react';
import { v2 } from '@/api/v2Client';

interface Props {
  documentId: string;
  formKeys: string[];
  onPopulate: (matches: Record<string, string>) => void;
}

function matchField(name: string, keys: string[]): string | null {
  const exact = keys.find((k) => k.toLowerCase() === name.toLowerCase());
  if (exact) return exact;
  return (
    keys.find(
      (k) =>
        name.toLowerCase().includes(k.toLowerCase()) ||
        k.toLowerCase().includes(name.toLowerCase()),
    ) ?? null
  );
}

export function ExtractFromPdfButton({ documentId, formKeys, onPopulate }: Props) {
  const [loading, setLoading] = useState(false);

  async function handleExtract() {
    setLoading(true);
    try {
      const result = await v2.documents.extractFields(documentId);
      const matches: Record<string, string> = {};
      for (const field of result.fields) {
        if (!field.value) continue;
        const key = matchField(field.name, formKeys);
        if (key) matches[key] = field.value;
      }
      onPopulate(matches);
    } catch {
      // Error handling is left to the caller or silent fallback
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      type="button"
      onClick={handleExtract}
      disabled={loading}
      style={{
        padding: '6px 14px',
        background: '#f3f4f6',
        color: '#374151',
        border: '1px solid #d1d5db',
        borderRadius: 6,
        cursor: loading ? 'not-allowed' : 'pointer',
        fontSize: 14,
        opacity: loading ? 0.6 : 1,
      }}
    >
      {loading ? 'Extracting…' : 'Extract from PDF'}
    </button>
  );
}
